<template>
  <v-flex :class="`xs${classTop}`" d-flex>
    <v-flex v-for="(counter, i) in data" :key="`counter_${i}`" :class="`xs${classColumns}`" d-flex>
      <v-layout v-if="!isFinish" row wrap>
        <v-flex v-for="(n, j) in counter.data" :key="`counter_${i}_${j}`" d-flex xs12>
          <v-card :class="{ 'lighten-1': n, 'lighten-5': !n, [counter.color]: true }" dark>
            <span />
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-flex>
</template>

<script>
const debug = require('debug')('OD::BoardScoreCounters')

export default {
  name: 'BoardScoreCounters',
  components: {},
  props: {
    counters: {
      type: Object,
      required: true,
    },
    isFinish: {
      type: Boolean,
      required: true,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      classTop: 0,
      classColumns: 0,
    }
  },
  computed: {
    data() {
      let data = this.counters
      if (this.reverse) {
        data = Object.values(data)
          .slice()
          .reverse()
      }
      debug('data', { counters: this.counters, data })
      return data
    },
  },
  watch: {
    counters() {
      this.calculateClasses()
    },
  },
  created() {
    this.calculateClasses()
  },
  beforeDestroy() {},
  methods: {
    calculateClasses() {
      const num = Object.keys(this.counters).length
      switch (num) {
        case 1:
          this.classTop = 2
          this.classColumns = 12
          break
        case 2:
          this.classTop = 2
          this.classColumns = 6
          break
        case 3:
          this.classTop = 2
          this.classColumns = 4
          break
        default:
          this.classTop = 0
          this.classColumns = 0
          break
      }
    },
  },
}
</script>

<style lang="scss">
</style>
